export const SUBMIT_PARTNER_PAYMENT_FORM = 'submitPartnerPaymentForm';
export const MANAGE_PARTNER_PAYMENT_INFO_FORM = 'managePartnerPaymentInfoForm';